import { render } from "./SwitchBoxField.vue?vue&type=template&id=78939b2c"
import script from "./SwitchBoxField.vue?vue&type=script&lang=js"
export * from "./SwitchBoxField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__